class LaravelErrorResponse {
    constructor(errors = {}) {
        this.errors = errors;
    }

    setErrors(errors) {
        this.errors = errors;
    }

    getError(field) {
        return this.errors[field] ? this.errors[field][0] : null;
    }

    getAllErrors(field) {
        return this.errors[field] || [];
    }

    hasError(field) {
        return !!this.errors[field];
    }

    getAll() {
        return this.errors;
    }

    hasAnyErrors() {
        return Object.keys(this.errors).length > 0;
    }

    clear() {
        this.errors = {};
    }

    clearField(field) {
        delete this.errors[field];
    }
}

export default LaravelErrorResponse;
